// F-482 (Leah, UAT3 — URS_12.1): the "your care team replied" indicator.
//
// ⛔ GREEN AND THE WORD "New", NEVER A RED COUNT. A red pill reads as an alert or an emergency,
// and a reply from the care team is neither. Every place the app marks a message thread (or the
// Messages entry) as having an unread reply uses this one component so the screens cannot
// drift back to red independently.
//
// ⚠️ The count is still the kernel's (`unread_from_care_team` / `sync.unread_replies`); it is
// kept as visually-hidden text so a screen reader still hears how many, while the visible label
// is the word the tester asked for.
//
// ⭐ ONE "New" MARK IN THE APP (F-495, R-877). The F-486 surveys "New" (Settings > CARE TEAM >
// Surveys and each waiting survey) uses this same component; only the screen-reader noun
// differs (`what`). Do not add a second "New" style — the reviewed look is this lime pill.
import React from "react";
import "./NewMessageIndicator.css";

type Props = {
  /** How many new things — announced, not shown. */
  count: number;
  slot?: string;
  /** What is new, singular and plural, for the screen-reader text. Defaults to unread replies. */
  what?: { one: string; many: string };
};

const UNREAD_REPLIES = { one: "unread reply", many: "unread replies" };

const NewMessageIndicator: React.FC<Props> = ({ count, slot, what = UNREAD_REPLIES }) => (
  <span className="new-message-indicator" slot={slot} data-testid="new-message-indicator">
    New
    <span className="new-message-indicator-sr">
      {`: ${count} ${count === 1 ? what.one : what.many}`}
    </span>
  </span>
);

export default NewMessageIndicator;
